import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const NumberFour: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 16.5c0-7.17 5.83-13 13-13s13 5.83 13 13-5.83 13-13 13-13-5.83-13-13Zm2 0c0 6.065 4.935 11 11 11s11-4.935 11-11-4.935-11-11-11-11 4.935-11 11Zm10.795-5.515h2.225v6.62h.95v1.82h-.95v2.09h-1.925v-2.09h-4.06v-.98l3.76-7.46Zm.435 6.695v-2.005l.105-2.18h-.015l-1.925 4.185h1.835Z"
      clipRule="evenodd"
    />
  </Icon>
);
